import useSplitedTable from '../../../hooks/useSplitedTable';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const _tables = [
  {
    name: 'Value for less than 5 years',
    key: 'less_five_years_risk_measure_value',
    letter: 'A'
  },
  {
    name: 'Value for 5 - 15 years',
    key: 'fifteen_years_risk_measure_value',
    letter: 'B'
  },
  {
    name: 'Value for greater than 15 years',
    key: 'more_fifteen_years_risk_measure_value',
    letter: 'C'
  },
  {
    name: 'Risk measure description',
    key: 'risk_measure_description',
    letter: 'D'
  }
];

const columnLables = {
  NET_DV01: {
    name: 'NET DV01',
    order: 182
  },
  NET_CS01: {
    name: 'NET CS01',
    order: 183
  }
};

export function ValueOfRisk({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useSplitedTable({
    data: funds[currentDataKey]?.fund_data?.VALUE_FOR_YEARS_RISK_MEASURE,
    onChangeFund,
    schema: schema.VALUE_FOR_YEARS_RISK_MEASURE,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.VALUE_FOR_YEARS_RISK_MEASURE?.field_names || [],
    isMultiFunds,
    funds,
    columnLables,
    tableName: 'VALUE_FOR_YEARS_RISK_MEASURE',
    tables: _tables,
    filderedFieldName: 'risk_measure_type'
  });

  return (
    <StyledTables id="fca-reporttables-value-of-risk-group">
      {tables.map((rows, index) => (
        <Table
          id={`fca-reporttables-value-of-risk-table-${index + 1}`}
          key={index + 'VALUE_FOR_YEARS_RISK_MEASURE'}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
        />
      ))}
    </StyledTables>
  );
}
